document.querySelectorAll('.Index_tab_feature_article_text_slider').forEach(el => {
  if (!el.classList.contains('swiper-initialized')) {
    new Swiper(el, {
        loop: false,
        grabCursor: false,
        spaceBetween: 24,
        slidesPerGroup: 1,
        slidesPerView: "auto",
        watchSlidesProgress: true,
        draggable: !0,
        autoHeight: !1,
        watchOverflow: !0,
        threshold: 10,
        mousewheel: {
            forceToAxis: !0
        },
        observer: true,
        observeParents: true,
        freeMode: !0,
        scrollbar: {
            el: ".swiper-scrollbar"
        },
        breakpoints: {
            0: {
                freeMode: !1,
                spaceBetween: 24,
            },
            750: {
                spaceBetween: 14,
            },
            990: {
                spaceBetween: 24,
            },
            1200: {
            },
            1440: {
            }
        }
    })
  }
});

document.querySelectorAll('.Index_tab_feature_article_item_slider').forEach(el => {
  if (!el.classList.contains('swiper-initialized')) {
    new Swiper(el, {
        loop: false,
        grabCursor: false,
        spaceBetween: 16,
        slidesPerGroup: 1,
        slidesPerView: 3,
        watchSlidesProgress: true,
        draggable: !0,
        autoHeight: !1,
        watchOverflow: !0,
        threshold: 10,
        mousewheel: {
            forceToAxis: !0
        },
        observer: true,
        observeParents: true,
        freeMode: !0,
        breakpoints: {
            0: {
                freeMode: !1,
                slidesPerView: "auto"
            },
            750: {
                slidesPerView: 3
            },
            990: {
            },
            1200: {
            },
            1440: {
            }
        }
    })
  }
});